import Translator from "../../utils/translator";
import { Dialog } from "./dialog";
import { CancelablePromise as Promise } from "../../utils/cancelablePromise";
import { getAndSaveNewImage } from "../../model/Image";
import { IImageResult, PictureSourceType } from "../../utils/native/nativeFileApi";
import { DriveStore } from "../../store/reducers";
import * as logger from "../../utils/logger";

export default class PictureOptionDialog {
    private readonly translator: Translator;
    private dialog: Dialog;
    private readonly store: DriveStore;
    private readonly isTrailer: boolean;

    constructor(translator: Translator, store: DriveStore, isTrailer: boolean) {
        this.translator = translator;
        this.store = store;
        this.isTrailer = isTrailer;
    }

    openImageDialog(cameraIconId = "", cb: ((imageResult: IImageResult) => void) | null = null) {
        this.dialog = new Dialog(
            "select-image",
            `Please choose an option to add an image.`,
            this.translator,
            "Adding Image...",
            [
                [{
                    text: "New picture",
                    id: "takePicture",
                    spinner: true,
                    callback: () => getAndSaveNewImage(PictureSourceType.CAMERA, this.store, cameraIconId, this.isTrailer, cb).then(() => {
                        this.close();
                    }).catch((e: Error) => {
                        logger.error(logger.Source.ERROR, e.message);
                        this.close();
                    })
                },
                {
                    text: "Upload",
                    id: "uploadPicture",
                    spinner: true,
                    callback: () => getAndSaveNewImage(PictureSourceType.PHOTOLIBRARY, this.store, cameraIconId, this.isTrailer, cb).then(() => {
                        this.close();
                    }).catch((e: Error) => {
                        logger.error(logger.Source.ERROR, e.message);
                        this.close();
                    })
                }]
            ],
            {
                isNightMode: this.store.getState().data.nightMode
            }
        );
        return this.dialog.open();
    }

    open(cameraIconId = "", cb: ((imageResult: IImageResult) => void) | null = null) {
        return new Promise<string | null>((resolve, reject) => {
            this.openImageDialog(cameraIconId, cb).then(dialog => {
                dialog.onRemove(resolve);
            }).catch(reject);
        });
    }

    close() {
        this.dialog && this.dialog.remove();
    }
}